module.exports = __webpack_public_path__ + "files/37173e10948d2d088c5d637761989b1b.png";